import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useHighwayPassesApi } from "../../http/highwayPasses/api";
import { formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";

import VersionDialog from "../ui/VersionDialog";

type HighwayPassHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const HighwayPassHistoryDialog: FC<HighwayPassHistoryDialogProps> = ({
  itemToShowVersionsId: itemToShowVersionsId,
  onClose,
  itemVersionToShowVersions,
}) => {
  const i18n = useI18n();
  const highwayPassesApi = useHighwayPassesApi();

  return (
    <HistoryDialog
      title={i18n.t.highwayPasses.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={highwayPassesApi.getAdminHighwayPassVersion}
      getHistory={highwayPassesApi.getAdminHighwayPassHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {(dataVersion.current?.car?.id ?? null) !== (dataVersion.next.car?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.cars.singular}
                  value={
                    dataVersion.current?.car?.currentPlateNumber ||
                    dataVersion.current?.car?.vehicleIdentificationNumber
                  }
                  edited={dataVersion.next.car?.currentPlateNumber || dataVersion.next.car?.vehicleIdentificationNumber}
                />
              </tr>
            )}
            {dataVersion.current?.nr != dataVersion.next.nr && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.number}
                  value={dataVersion.current?.nr}
                  edited={dataVersion.next.nr}
                />
              </tr>
            )}
            {dataVersion.current?.startDate != dataVersion.next.startDate && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.startDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.startDate, i18n.language)}
                  edited={formatDate(dataVersion.next?.startDate, i18n.language)}
                />
              </tr>
            )}
            {(!dataVersion.current || dataVersion?.current?.endDate !== dataVersion.next.endDate) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.endDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.endDate!, i18n.language)}
                  edited={formatDate(dataVersion.next?.endDate!, i18n.language)}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default HighwayPassHistoryDialog;
